import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import cn from 'classnames';
import Page from '@Containers/Page';
import InProductMessages from '@Containers/InProductMessages';
import Auth from '@Services/Auth';
import { FEATURES } from '@Constants/rx-ui/constants';
import PropTypes from 'prop-types';
import SimpleSpinner from '../../Components/Results/utils/SimpleSpinner';
import { initializeQuickSearch } from './QuickSearchActions';
import BuildQuery from './Components/BuildQuery/BuildQueryContainer';
import QuickResults from './Components/QuickResults/QuickResultsContainer';
import { QUICK_SEARCH_ROUTE, QUICK_SEARCH_ROUTES } from './routes';
import { SPINNER_ID } from './QuickSearchConstants';

function QuickSearch({ action, searchId }) {
  const [initialized, setInitialized] = useState(false);
  const isAIQuickSearchBannerDisabled = Auth.isFeatureEnabled(FEATURES.disableAIQuickSearchBanner);

  useEffect(() => {
    initializeQuickSearch(action).then(() => {
      setInitialized(true);
    });
  }, [action]);

  return (
    <Page headerType="main" withFooter pageClassName="quick-search-page">
      <main
        className={cn('quick-search page-container', { 'page-container--hexagons': isAIQuickSearchBannerDisabled })}
        aria-label="Quick Search"
        data-e2e="quick-search-page">
        <InProductMessages />
        {initialized ? (
          <Switch>
            <Route path={QUICK_SEARCH_ROUTE} exact render={() => <SimpleSpinner id={SPINNER_ID} />} />
            <Route path={QUICK_SEARCH_ROUTES.QUERY} render={() => <BuildQuery />} />
            <Route path={QUICK_SEARCH_ROUTES.RESULTS} render={() => <QuickResults key={searchId} searchId={searchId} />} />
          </Switch>
        ) : (
          <SimpleSpinner id={SPINNER_ID} />
        )}
      </main>
    </Page>
  );
}

QuickSearch.propTypes = {
  action: PropTypes.string,
  searchId: PropTypes.string,
};

export default QuickSearch;
